import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { attachmentStatuses } from '../../util/attachmentConsts'
import { openFoiLetterInNewWindow, openFoiBillInNewWindow } from '../../util/openInNewWindow'
import { Divider, FlexColumn, SpaceBetweenRowContainer } from '../styles/Containers'
import { BoldMedBodyText } from '../styles/Text'
import OpenInNewTabButton from '../common/OpenInNewTabButton'
import AttachmentStatus from './AttachmentStatus'

const RowContainer = styled(SpaceBetweenRowContainer)`
  padding: 0 20px;
`

const labelMap = {
  BILL: 'View bill in new tab',
  LETTER: 'View letter in new tab'
}

function SelectedAttachment({ foiId, attachmentType, attachment, disabled = false, showStatus = false }) {
  const openFunctionMap = {
    BILL: () => openFoiBillInNewWindow(foiId, attachment.id),
    LETTER: () => openFoiLetterInNewWindow(foiId, attachment.id)
  }

  return (
    <SpaceBetweenRowContainer gap="10px">
      <FlexColumn gap={showStatus ? '5px' : '14px'} width="100%">
        <Divider />
        <RowContainer>
          <BoldMedBodyText>{attachment.name}</BoldMedBodyText>
          {showStatus && attachment.state !== 'SENT' && <AttachmentStatus status={attachment.status} />}
        </RowContainer>
        <Divider />
      </FlexColumn>
      <OpenInNewTabButton label={labelMap[attachmentType]} onClick={openFunctionMap[attachmentType]} disabled={disabled} />
    </SpaceBetweenRowContainer>
  )
}

SelectedAttachment.propTypes = {
  foiId: PropTypes.string.isRequired,
  attachmentType: PropTypes.oneOf(['BILL', 'LETTER']).isRequired,
  attachment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(attachmentStatuses),
    state: PropTypes.oneOf(['DRAFT', 'SENT'])
  }).isRequired,
  disabled: PropTypes.bool,
  showStatus: PropTypes.bool
}

export default SelectedAttachment
